/**
 * Event bus for authentication state changes (login/logout).
 * Enables decoupled communication between services when auth state changes.
 */
class AuthEventService {
    private static listeners: Set<(event: 'login' | 'logout') => void> = new Set()
    
    /**
     * Subscribe to auth events.
     * @param callback Handler for login/logout events
     * @returns Unsubscribe function
     */
    static subscribe(callback: (event: 'login' | 'logout') => void): () => void {
        this.listeners.add(callback)
        return () => {
            this.listeners.delete(callback)
        }
    }
    
    /** Notify all listeners of logout event. */
    static emitLogout(): void {
        this.listeners.forEach(callback => callback('logout'))
    }
    
    /** Notify all listeners of login event. */
    static emitLogin(): void {
        this.listeners.forEach(callback => callback('login'))
    }
}

export default AuthEventService